import {useBackdropPreloaderStore} from '../../../../../../../../../../Stores/backdropPreloader';

import FormContainer from '../../../../../../../../../../Components/Form/FormContainer';

export default function DeliveryStep(props) {
    const {submit, content, belongsToLibrary} = props;

    const {hideBackdropPreloader} = useBackdropPreloaderStore()

    if (belongsToLibrary) {
        const config = {
            fields: {
                location: {
                    type: 'location',
                    placeholder: 'Адреса доставки',
                    required: true,
                },
                name: {
                    default: 'template:user.name',
                    type: 'text',
                    placeholder: 'Ім\'я отримувача',
                    required: true,
                },
                whatsapp: {
                    default: 'template:user.messenger',
                    type: 'phone',
                    placeholder: 'WhatsApp отримувача',
                    required: true,
                }
            },
            form: {
                submitNotice: '<b>Книгу буде відправлено за рахунок читача</b>. Будь ласка, підготуйте готівку для сплати водію. Перед відправкою, ми напишемо вам, для узгодження часу доставки.',
                submitText: "Забронювати книгу",
            }
        };

        const onSubmit = (data) => {
            hideBackdropPreloader();
            submit(data);
        }

        return <div className="DeliveryStep">
            <div className="rule">
                <span className='sectionIcon'>🛵 </span>
                <span>Введіть дані для доставки з Gojek або Grab</span>
            </div>
            {/* <p className='textNotes'>Книгу буде відправлено за рахунок читача. Будь ласка, підготуйте готівку для сплати водію</p> */}

            <FormContainer
                config={config}
                submitHandler={onSubmit}
            />
        </div>
    }
}
